module.exports = __webpack_public_path__ + "media/out.2f2cd420.mp4";